import { useState } from 'react';
import { Button, Typography, Grid } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import { ProjectDto } from '@/core';
import { ProjectModal } from '../Projects.List/ProjectModal';
import { useGetProjectsQuery } from '@/redux';
import classes from './ProjectDescription.module.scss';

const { useBreakpoint } = Grid;

type ProjectDescriptionPropsType = {
  projectData: ProjectDto;
};

export const ProjectDescription = ({ projectData }: ProjectDescriptionPropsType) => {
  const screens = useBreakpoint();
  const isMobileScreen = !screens.sm;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: projectsData } = useGetProjectsQuery();

  return (
    <>
      <div className={isMobileScreen ? classes.titleWrapper__mobile : classes.titleWrapper}>
        <Typography.Title level={3}>{projectData.name}</Typography.Title>
        {isMobileScreen ? (
          <Button
            type="text"
            onClick={() => setIsModalOpen(true)}
            className={classes.renameBtn__mobile}
            icon={<EditOutlined className={classes.renameBtnIcon} />}
          />
        ) : (
          <Button size="large" onClick={() => setIsModalOpen(true)}>
            Rename
          </Button>
        )}
      </div>
      {projectData.description && (
        <Typography.Text type="secondary">{projectData.description}</Typography.Text>
      )}
      {projectsData && (
        <ProjectModal
          isModalOpen={isModalOpen}
          setIsModalOpen={(value: boolean) => setIsModalOpen(value)}
          editedProject={projectData}
          projectsListData={projectsData}
          stopEdit={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
};
